<script setup lang="ts">
import {
  mdiClose,
  mdiAlertOutline,
  mdiCheckCircleOutline,
  mdiAlertCircleOutline,
  mdiInformationBoxOutline,
} from '@mdi/js'
import { useToaster } from '../composables/use-toaster'
import type { Variant } from '@/shared/types/shared.types'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'
import BaseButton from '@/shared/components/button/BaseButton.vue'
import ToastTransition from '@/shared/components/transitions/ToastTransition.vue'
import ToastLoader from '@/modules/toaster/components/ToastLoader.vue'

const { toasts, remove } = useToaster()

const getIcon: Record<Variant, string> = {
  success: mdiCheckCircleOutline,
  warning: mdiAlertOutline,
  error: mdiAlertCircleOutline,
  info: mdiInformationBoxOutline,
}

const getClass: Record<Variant, string> = {
  success: 'fill-success',
  warning: 'fill-warning',
  error: 'fill-error',
  info: 'fill-info',
}

</script>

<template>
  <div class="z-40 fixed bottom-12 right-4 space-y-2">
    <ToastTransition>
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="flex relative items-center bg-black/90 ps-3 pb-1 shadow-lg rounded-lg overflow-hidden"
      >
        <div class="inline-flex items-center justify-center me-2">
          <SvgIcon :path="getIcon[toast.variant]" class="h-10 w-10" :class="getClass[toast.variant]" />
        </div>
        <div class="font-light text-sm text-white me-4 text-nowrap">
          {{ toast.params ? $t(toast.message, toast.params) : $t(toast.message) }}
        </div>
        <div class="flex items-center justify-end w-full">
          <BaseButton
            :title="$t('common.close')"
            class="group flex items-center justify-center hover:bg-gray-700/30 hover:shadow-inner border-l border-gray-700 p-2 rounded-e-xl"
            @click="remove(toast.id)"
          >
            <SvgIcon :path="mdiClose" class="fill-white w-6 h-12 group-hover:fill-white" />
            <span class="sr-only">{{ $t('common.close') }}</span>
          </BaseButton>
          <ToastLoader v-model="toast.progress" :variant="toast.variant" />
        </div>
      </div>
    </ToastTransition>
  </div>
</template>
